import {forEach, keys, isNil, isEmpty, includes} from 'lodash/lodash.min'
import GonCampaignAccessor from './gon_campaign_accessor'

export default () => {
    // GonCampaignAccessorを使用してgon.campaignからデータを取得
    // entry_buttons.object_with_entry_type 自体が未設定なら早期return。
    // 空オブジェクトの場合はループに進み、HTML上に残った gampla-entry-btn を削除対象とする。
    // （後段で利用する entryButtonObject は getter が常に {} 以上を返すため undefined 判定の用途には使えない）
    const gonCampaignAccessor = new GonCampaignAccessor()
    if (gonCampaignAccessor.entryButtonObjectWithEntryType === undefined) return

    const removedElement = []
    const entryButtonObject = gonCampaignAccessor.entryButtonObject
    const entryButtonEntityIDs = keys(entryButtonObject)
    const entryButtonDisplay = gonCampaignAccessor.entryButtonDisplay

    forEach(document.getElementsByTagName('gampla-entry-btn'), (element) => {

        // HTMLのattribute-idは本来一意なので、複数同じボタンが存在できない。 (grapesjs上でIDの重複ができない)
        // それを解決するためにidいがいに data-entity-id を受ける
        let id = element.id;

        // grapesjsの場合にはIDが自動付与されれてしまうため、data-entity-idが存在する場合には上書き
        // DataSet Name Conversion https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset#name_conversion
        const data_id = element.dataset.entityId
        if(data_id) {
            id = data_id
        }
        // 以下の条件を満たすgampla-entry-btn タグのinnerHTML属性に、ボタン名を代入する
        //   1. エントリーボタン管理画面上に存在する
        //   2. html 上に存在している
        //   3. innerHTMLが存在しない (モジュールテンプレート対応)
        if (includes(entryButtonEntityIDs, id) && (isNil(element.innerHTML) || isEmpty(element.innerHTML))) {
            element.innerHTML = entryButtonObject[id];
        }

        // 以下の条件のどちらかを満たすgampla-entry-btn タグを、削除対象として配列に格納する
        //   - エントリーボタン管理画面上に存在しない && html 上に存在している場合
        //   - controller 側でボタン非表示と判定された場合
        if (entryButtonDisplay === false || !includes(entryButtonEntityIDs, id)) {
            removedElement.push(element)
        }
    })
    forEach(removedElement, (element) => { element.parentNode.removeChild(element) })
}